const es = {
  header: {
    badge: "Guía Oficial de BotMix",
    title: "Centro de Mensajería Omnicanal — Inbox de Chat",
    summary:
      "El Inbox de Chat es el centro operativo principal para la atención de clientes en tiempo real. Unifica todas las conversaciones provenientes de WhatsApp (Baileys y API Oficial de Meta), Facebook Messenger, Instagram Direct y Web Widget en una sola interfaz organizada por pestañas y filas/departamentos de atención.",
  },
  sections: [
    {
      id: "pestanas_estados",
      title: "1. Pestañas de Navegación y Acciones del Ticket",
      description:
        "Las 3 ventanas principales de trabajo en el Inbox y los botones de acción disponibles en cada una.",
      items: [
        {
          id: "tab_esperando",
          title: "⏳ Esperando (Tickets Pendientes)",
          definition:
            "Bandeja de mensajes entrantes que aún no han sido tomados por un asesor o que aguardan en la fila/departamento tras interactuar con un chatbot. El ticket permanece en estado pendiente.",
          importance:
            "Botones disponibles en cada ticket:\n• Aceptar (✓): Toma la conversación, se asigna a tu usuario y la traslada a 'Trabajando en'.\n• Transferir (⇄): Deriva el ticket a otra fila/departamento o a otro asesor.\n• Ignorar (🚫): Descarta el mensaje (spam o error) sin contabilizarlo como atención atendida.\n(Nota: Si deseas dar por concluida la conversación sin abrirla, puedes hacerlo directamente con la opción 'Cerrar' del menú de 3 puntos ⋮ en la cabecera del chat).",
        },
        {
          id: "tab_trabajando_en",
          title: "💼 Trabajando en (Tickets Abiertos)",
          definition:
            "Conversaciones activas que ya fueron aceptadas por un asesor. Aquí interactúas con el cliente enviando respuestas, notas de voz, archivos y notas internas.",
          importance:
            "Botones disponibles en cada ticket:\n• Cerrar (❌): Finaliza formalmente la atención una vez completada la gestión.\n• Transferir (⇄): Deriva la conversación activa a otro asesor o departamento.",
        },
        {
          id: "tab_grupos",
          title: "👥 Grupos (Grupos de WhatsApp)",
          definition:
            "Bandeja dedicada exclusivamente a la visualización y gestión de comunidades y chats grupales conectados a la empresa.",
          importance:
            "Botones disponibles en cada ticket:\n• Cerrar (❌): Finaliza el ciclo de seguimiento del grupo.\n• Transferir (⇄): Reasigna la gestión del grupo a otro asesor o equipo.",
        },
      ],
    },
    {
      id: "controles_busqueda",
      title: "2. Búsqueda y Filtros Avanzados",
      description:
        "Herramientas para localizar conversaciones por criterios específicos.",
      items: [
        {
          id: "buscador_rapido",
          title: "Buscador Predictivo",
          definition:
            "Permite buscar chats al instante por nombre de contacto, número de teléfono o contenido del último mensaje.",
        },
        {
          id: "filtros_avanzados",
          title: "Filtros Avanzados (Embudo, Etapas y Fechas)",
          definition:
            "Modal desplegable para segmentar por marca, embudo CRM, etapa Kanban, conexión de origen, usuario asignado o etiquetas.",
        },
      ],
    },
    {
      id: "acciones_chat",
      title: "3. Herramientas del Chat y Mensajería",
      description:
        "Funcionalidades disponibles dentro de la ventana de conversación activa al interactuar con el cliente.",
      items: [
        {
          id: "notas_internas",
          title: "Notas Internas y Mensajes Privados",
          definition:
            "Permite a los asesores registrar anotaciones y comentarios internos dentro del chat. Son completamente invisibles para el cliente y quedan guardadas en el historial de la empresa.",
        },
        {
          id: "mensajes_programados",
          title: "Programación de Mensajes y Recordatorios",
          definition:
            "Permite programar mensajes para ser enviados en una fecha y hora específicas en el futuro, con opciones de recurrencia periódica y segundo recordatorio automático.",
        },
        {
          id: "adjuntos_multimedia",
          title: "Herramientas Multimedia y Adjuntos",
          definition:
            "Soporte integral para enviar notas de voz grabadas en tiempo real, archivos de audio, fotos, videos, documentos (PDF, Excel, Word) y fichas de contacto vCard.",
        },
        {
          id: "transferencia",
          title: "Transferencia entre Filas/Departamentos o Asesores",
          definition:
            "Deriva el ticket a otra área de la empresa (ej: de Ventas a Soporte) transfiriendo todo el historial intacto.",
        },
        {
          id: "respuestas_rapidas",
          title: "Respuestas Rápidas (Atajo '/')",
          definition:
            "Escribe una barra '/' en el campo de texto para desplegar plantillas predefinidas y audios grabados.",
        },
        {
          id: "disparar_flujo",
          title: "Disparo Manual de Flujos y Automatizaciones",
          definition:
            "Ejecuta un flujo del bot manualmente sobre la conversación. La lista de flujos se filtra inteligentemente según la Marca comercial y el Embudo asignados al ticket, garantizando que solo se envíen automatizaciones pertinentes.",
        },
        {
          id: "firma_asesor",
          title: "Firma Automática del Asesor",
          definition:
            "Activa o desactiva la inclusión automática del nombre del asesor al inicio de cada mensaje enviado para una atención personalizada y transparente.",
        },
      ],
    },
    {
      id: "accesos_cabecera",
      title: "4. Accesos Directos de la Cabecera del Chat",
      description:
        "Botones de acción rápida ubicados en la barra superior de la conversación activa.",
      items: [
        {
          id: "copiar_numero",
          title: "Copiar Teléfono / Contacto",
          definition:
            "Copia al portapapeles el número telefónico del cliente con un solo clic para pegarlo en llamadas externas o notas, respetando el prefijo si está configurado.",
        },
        {
          id: "respuestas_rapidas_icono",
          title: "Respuestas Rápidas (Rayo ⚡)",
          definition:
            "Abre de inmediato la ventana modal de respuestas rápidas y audios prediseñados para insertarlos o enviarlos al cliente al instante.",
        },
        {
          id: "switch_chatbot",
          title: "Activar / Desactivar Chatbot para este Contacto",
          definition:
            "Interruptor rápido para pausar o reactivar las respuestas automáticas del bot y de la IA exclusivamente para este contacto, permitiendo una atención 100% humana sin interferencias.",
        },
        {
          id: "boton_aceptar",
          title: "Botón Aceptar (Tickets en Espera)",
          definition:
            "Visible cuando el ticket está en la bandeja de Esperando. Asigna la conversación a tu asesor y la traslada automáticamente a 'Trabajando en' para iniciar la atención.",
        },
      ],
    },
    {
      id: "menu_opciones_ticket",
      title: "5. Menú de Opciones del Ticket (Tres Puntos ⋮)",
      description:
        "Opciones avanzadas de gestión disponibles en el menú desplegable de la cabecera.",
      items: [
        {
          id: "opcion_cerrar",
          title: "Cerrar Ticket (❌)",
          definition:
            "Finaliza formalmente la atención del ticket. Permite elegir si enviar o no mensaje de despedida automático (o capturar el valor de venta si la función está activa). Puede utilizarse tanto en tickets abiertos como en espera.",
        },
        {
          id: "opcion_regresar_fila",
          title: "Regresar a la Fila / Departamento (↩️)",
          definition:
            "Libera la conversación desasignándola de tu usuario y devolviéndola al estado de Espera dentro de su departamento para que cualquier otro asesor disponible pueda atenderla.",
        },
        {
          id: "opcion_transferir",
          title: "Transferir Ticket (⇄)",
          definition:
            "Abre el modal de transferencia para reasignar la conversación a otro departamento o a un asesor específico, conservando todo el historial de mensajes de forma transparente.",
        },
        {
          id: "opcion_borrar",
          title: "Borrar Ticket (🗑️)",
          definition:
            "Elimina permanentemente el ticket y su historial de la base de datos previa confirmación de seguridad. Exclusivo para administradores del sistema.",
        },
        {
          id: "opcion_logs",
          title: "Logs del Ticket (📜)",
          definition:
            "Muestra la traza cronológica completa y auditoría forense del ticket: fecha de creación, tiempos de espera, asignaciones de agentes, transferencias y cierres.",
        },
        {
          id: "opcion_pdf",
          title: "Exportar para PDF (📄)",
          definition:
            "Genera y descarga un documento PDF con el resumen completo de la conversación, contactos, fechas y mensajes enviados para respaldo administrativo o legal.",
        },
      ],
    },
  ],
};

const en = {
  header: {
    badge: "BotMix Official Guide",
    title: "Omnichannel Messaging Center — Chat Inbox",
    summary:
      "The Chat Inbox is the main operational center for real-time customer service. It unifies all conversations from WhatsApp (Baileys and Official Meta API), Facebook Messenger, Instagram Direct, and Web Widget in a single interface organized by tabs and queues/departments.",
  },
  sections: [
    {
      id: "pestanas_estados",
      title: "1. Navigation Tabs and Ticket Actions",
      description:
        "The 3 main workspaces in Inbox and available action buttons in each.",
      items: [
        {
          id: "tab_esperando",
          title: "⏳ Waiting (Pending Tickets)",
          definition:
            "Inbox of incoming messages not yet taken by an agent or waiting in queue/department after interacting with a chatbot. The ticket remains in pending status.",
          importance:
            "Buttons available on each ticket:\n• Accept (✓): Takes the conversation, assigns it to your user and moves it to 'Working on'.\n• Transfer (⇄): Reroutes the ticket to another queue/department or agent.\n• Ignore (🚫): Discards the message (spam or error) without counting it as attended service.\n(Note: If you want to finalize the conversation without opening it, you can do so directly using the 'Close' option in the 3-dots menu ⋮ in the chat header).",
        },
        {
          id: "tab_trabajando_en",
          title: "💼 Working on (Open Tickets)",
          definition:
            "Active conversations already accepted by an agent. Here you interact with the customer by sending replies, voice notes, files, and internal notes.",
          importance:
            "Buttons available on each ticket:\n• Close (❌): Formally finalizes customer care once service is complete.\n• Transfer (⇄): Derives the active conversation to another agent or department.",
        },
        {
          id: "tab_grupos",
          title: "👥 Groups (WhatsApp Groups)",
          definition:
            "Workspace dedicated exclusively to viewing and managing WhatsApp groups and communities connected to the company.",
          importance:
            "Buttons available on each ticket:\n• Close (❌): Concludes the tracking cycle for the group.\n• Transfer (⇄): Reassigns group management to another agent or team.",
        },
      ],
    },
    {
      id: "controles_busqueda",
      title: "2. Search and Advanced Filters",
      description:
        "Tools to locate conversations by specific criteria.",
      items: [
        {
          id: "buscador_rapido",
          title: "Predictive Search",
          definition:
            "Instantly searches chats by contact name, phone number, or content of the latest message.",
        },
        {
          id: "filtros_avanzados",
          title: "Advanced Filters (Funnel, Stages, and Dates)",
          definition:
            "Dropdown modal to filter by commercial brand, CRM funnel, Kanban stage, connection, assigned user, or tags.",
        },
      ],
    },
    {
      id: "acciones_chat",
      title: "3. Chat and Messaging Tools",
      description:
        "Features available inside the active conversation window when interacting with the customer.",
      items: [
        {
          id: "notas_internas",
          title: "Internal Notes and Private Messages",
          definition:
            "Allows agents to record private annotations inside the chat. These are completely hidden from the client and saved in company history.",
        },
        {
          id: "mensajes_programados",
          title: "Scheduled Messages and Reminders",
          definition:
            "Schedules messages to be sent at specific future dates and times, including periodic recurrence and automatic second reminders.",
        },
        {
          id: "adjuntos_multimedia",
          title: "Multimedia Attachments",
          definition:
            "Comprehensive support for sending live voice recordings, audio files, photos, videos, documents (PDF, Excel, Word), and vCard contacts.",
        },
        {
          id: "transferencia",
          title: "Transfer Between Queues or Agents",
          definition:
            "Reroutes the ticket to another department (e.g., from Sales to Support) while keeping the entire conversation history intact.",
        },
        {
          id: "respuestas_rapidas",
          title: "Quick Answers (Shortcut '/')",
          definition:
            "Type a slash '/' in the text field to display pre-configured templates and recorded voice notes.",
        },
        {
          id: "disparar_flujo",
          title: "Manual Flow and Automation Trigger",
          definition:
            "Manually triggers a chatbot flow on the active conversation. Flows are intelligently filtered based on the Brand and CRM Funnel assigned to the ticket.",
        },
        {
          id: "firma_asesor",
          title: "Agent Signature",
          definition:
            "Enables or disables automatic inclusion of the attending agent's name on each outgoing message for transparent customer care.",
        },
      ],
    },
    {
      id: "accesos_cabecera",
      title: "4. Chat Header Quick Shortcuts",
      description:
        "Quick action buttons located at the top bar of the active conversation.",
      items: [
        {
          id: "copiar_numero",
          title: "Copy Phone / Contact",
          definition:
            "Copies the customer's phone number to clipboard with a single click, respecting custom prefixes if configured.",
        },
        {
          id: "respuestas_rapidas_icono",
          title: "Quick Answers (Lightning ⚡)",
          definition:
            "Immediately opens the modal for quick response templates and pre-recorded audios to send to the client.",
        },
        {
          id: "switch_chatbot",
          title: "Enable / Disable Chatbot for Contact",
          definition:
            "Quick toggle to pause or resume automated bot and AI responses exclusively for this contact, allowing uninterrupted 100% human assistance.",
        },
        {
          id: "boton_aceptar",
          title: "Accept Button (Pending Tickets)",
          definition:
            "Visible when the ticket is in the Waiting tab. Assigns the conversation to your agent and automatically moves it to 'Working on' to begin service.",
        },
      ],
    },
    {
      id: "menu_opciones_ticket",
      title: "5. Ticket Options Menu (Three Dots ⋮)",
      description:
        "Advanced management options available in the header dropdown menu.",
      items: [
        {
          id: "opcion_cerrar",
          title: "Close Ticket (❌)",
          definition:
            "Formally finalizes the ticket. Lets you choose whether to send an automatic farewell message (or record sales data if enabled). Can be used on both open and waiting tickets.",
        },
        {
          id: "opcion_regresar_fila",
          title: "Return to Queue / Department (↩️)",
          definition:
            "Releases the conversation by unassigning your user and returning it to Waiting status in its queue so another available agent can take it.",
        },
        {
          id: "opcion_transferir",
          title: "Transfer Ticket (⇄)",
          definition:
            "Opens the transfer modal to reassign the conversation to another department or specific agent, keeping the full message history intact.",
        },
        {
          id: "opcion_borrar",
          title: "Delete Ticket (🗑️)",
          definition:
            "Permanently deletes the ticket and its history from the database after confirmation. Restricted to system administrators.",
        },
        {
          id: "opcion_logs",
          title: "Ticket Logs (📜)",
          definition:
            "Displays the complete chronological timeline and audit trail of the ticket: creation time, wait duration, agent assignments, transfers, and closures.",
        },
        {
          id: "opcion_pdf",
          title: "Export to PDF (📄)",
          definition:
            "Generates and downloads a PDF document containing the entire chat history, contacts, dates, and messages for administrative or legal records.",
        },
      ],
    },
  ],
};

const pt = {
  header: {
    badge: "Guia Oficial do BotMix",
    title: "Central de Mensagens Omnichannel — Inbox de Chat",
    summary:
      "O Inbox de Chat é o centro operacional principal para atendimento de clientes em tempo real. Unifica todas as conversas do WhatsApp (Baileys e API Oficial da Meta), Facebook Messenger, Instagram Direct e Web Widget em uma interface organizada por abas e departamentos.",
  },
  sections: [
    {
      id: "pestanas_estados",
      title: "1. Abas de Navegação e Ações do Ticket",
      description:
        "As 3 janelas principais de trabalho no Inbox e os botões de ação disponíveis em cada uma.",
      items: [
        {
          id: "tab_esperando",
          title: "⏳ Aguardando (Tickets Pendentes)",
          definition:
            "Caixa de entrada de mensagens que ainda não foram aceitas por um atendente ou aguardam na fila após interação com o chatbot. O ticket permanece pendente.",
          importance:
            "Botões disponíveis:\n• Aceitar (✓): Assume a conversa e a transfere para 'Atendendo'.\n• Transferir (⇄): Encaminha o ticket para outra fila ou atendente.\n• Ignorar (🚫): Descarta a mensagem sem contabilizá-la como atendimento.\n(Nota: Caso deseje finalizar a conversa sem abri-la, você pode usar a opção 'Fechar' no menu de 3 pontos ⋮ no cabeçalho do chat).",
        },
        {
          id: "tab_trabajando_en",
          title: "💼 Atendendo (Tickets Abertos)",
          definition:
            "Conversas ativas aceitas por um atendente para interagir com o cliente enviando respostas, áudios, anexos e notas internas.",
          importance:
            "Botões disponíveis:\n• Fechar (❌): Finaliza formalmente o atendimento concluído.\n• Transferir (⇄): Encaminha a conversa ativa para outro atendente ou departamento.",
        },
        {
          id: "tab_grupos",
          title: "👥 Grupos (Grupos de WhatsApp)",
          definition:
            "Área dedicada exclusivamente à visualização e gestão de grupos e comunidades de WhatsApp conectados à empresa.",
          importance:
            "Botões disponíveis:\n• Fechar (❌): Encerra o ciclo de acompanhamento do grupo.\n• Transferir (⇄): Reatribui a gestão do grupo a outro atendente.",
        },
      ],
    },
    {
      id: "controles_busqueda",
      title: "2. Busca e Filtros Avançados",
      description:
        "Ferramentas para localizar conversas por critérios específicos.",
      items: [
        {
          id: "buscador_rapido",
          title: "Busca Preditiva",
          definition:
            "Permite pesquisar conversas instantaneamente por nome, telefone ou texto da última mensagem.",
        },
        {
          id: "filtros_avanzados",
          title: "Filtros Avançados (Funil, Etapas e Datas)",
          definition:
            "Modal para filtrar por marca, funil CRM, etapa Kanban, conexão de origem, usuário ou etiquetas.",
        },
      ],
    },
    {
      id: "acciones_chat",
      title: "3. Ferramentas do Chat e Mensagens",
      description:
        "Recursos disponíveis dentro da janela de conversa ativa durante o atendimento ao cliente.",
      items: [
        {
          id: "notas_internas",
          title: "Notas Internas e Mensagens Privadas",
          definition:
            "Permite registrar anotações internas dentro do chat. Invisíveis para o cliente e salvas no histórico da empresa.",
        },
        {
          id: "mensajes_programados",
          title: "Agendamento de Mensagens e Lembretes",
          definition:
            "Permite programar envios para datas e horas futuras, com suporte a recorrência periódica e segundo lembrete.",
        },
        {
          id: "adjuntos_multimedia",
          title: "Anexos Multimídia e Contatos",
          definition:
            "Suporte para gravação de áudio em tempo real, envio de arquivos, imagens, vídeos, documentos (PDF, Office) e vCards.",
        },
        {
          id: "transferencia",
          title: "Transferência entre Filas ou Atendentes",
          definition:
            "Transfere o ticket para outro departamento (ex: de Vendas para Suporte) preservando todo o histórico.",
        },
        {
          id: "respuestas_rapidas",
          title: "Respostas Rápidas (Atalho '/')",
          definition:
            "Digite '/' no campo de texto para exibir modelos pré-cadastrados e mensagens de voz gravadas.",
        },
        {
          id: "disparar_flujo",
          title: "Disparo Manual de Fluxos e Automações",
          definition:
            "Dispara fluxos do bot manualmente. Os fluxos são filtrados de forma inteligente pela Marca e Funil atribuídos ao ticket.",
        },
        {
          id: "firma_asesor",
          title: "Assinatura do Atendente",
          definition:
            "Ativa ou desativa a assinatura com o nome do atendente em cada mensagem enviada.",
        },
      ],
    },
    {
      id: "accesos_cabecera",
      title: "4. Atalhos Rápidos do Cabeçalho do Chat",
      description:
        "Botões de ação rápida localizados na barra superior da conversa ativa.",
      items: [
        {
          id: "copiar_numero",
          title: "Copiar Telefone / Contato",
          definition:
            "Copia o número do cliente para a área de transferência com um clique, respeitando o prefixo configurado.",
        },
        {
          id: "respuestas_rapidas_icono",
          title: "Respostas Rápidas (Raio ⚡)",
          definition:
            "Abre instantaneamente a janela de respostas rápidas e áudios pré-gravados para envio imediato.",
        },
        {
          id: "switch_chatbot",
          title: "Ativar / Desativar Chatbot para este Contato",
          definition:
            "Interruptor para pausar ou reativar as respostas automáticas do bot e da IA exclusivamente para este contato.",
        },
        {
          id: "boton_aceptar",
          title: "Botão Aceitar (Tickets Aguardando)",
          definition:
            "Visível quando o ticket está na aba Aguardando. Atribui a conversa a você e a move para 'Atendendo' para iniciar o atendimento.",
        },
      ],
    },
    {
      id: "menu_opciones_ticket",
      title: "5. Menu de Opções do Ticket (Três Pontos ⋮)",
      description:
        "Opções avançadas de gestão disponíveis no menu suspenso do cabeçalho.",
      items: [
        {
          id: "opcion_cerrar",
          title: "Fechar Ticket (❌)",
          definition:
            "Finaliza formalmente o atendimento. Permite escolher se envia ou não mensagem de despedida (ou registrar valor da venda). Pode ser usado em tickets abertos ou aguardando.",
        },
        {
          id: "opcion_regresar_fila",
          title: "Retornar à Fila / Departamento (↩️)",
          definition:
            "Libera a conversa removendo a atribuição e retornando-a para a fila do departamento para que outro atendente possa assumir.",
        },
        {
          id: "opcion_transferir",
          title: "Transferir Ticket (⇄)",
          definition:
            "Abre o modal de transferência para encaminhar a conversa para outro departamento ou atendente específico mantendo todo o histórico.",
        },
        {
          id: "opcion_borrar",
          title: "Excluir Ticket (🗑️)",
          definition:
            "Remove permanentemente o ticket e seu histórico do banco de dados após confirmação. Restrito a administradores.",
        },
        {
          id: "opcion_logs",
          title: "Logs do Ticket (📜)",
          definition:
            "Exibe o histórico cronológico e auditoria do ticket: data de criação, tempo de espera, atribuições, transferências e encerramentos.",
        },
        {
          id: "opcion_pdf",
          title: "Exportar para PDF (📄)",
          definition:
            "Gera e baixa um arquivo PDF com o histórico completo da conversa, contatos, datas e mensagens para fins de arquivo ou auditoria.",
        },
      ],
    },
  ],
};

const fr = {
  header: {
    badge: "Guide Officiel de BotMix",
    title: "Centre de Messagerie Omnicanal — Boîte de Réception",
    summary:
      "La boîte de réception de chat est le centre opérationnel principal pour le service client en temps réel. Elle regroupe les échanges issus de WhatsApp (Baileys et API officielle Meta), Facebook Messenger, Instagram Direct et Web Widget.",
  },
  sections: [
    {
      id: "pestanas_estados",
      title: "1. Onglets de Navigation et Actions sur les Tickets",
      description:
        "Les 3 espaces de travail principaux et les actions disponibles dans chacun.",
      items: [
        {
          id: "tab_esperando",
          title: "⏳ En attente (Tickets en attente)",
          definition:
            "Boîte de réception des messages entrants non encore assignés ou en file d'attente après interaction avec le bot. Le ticket reste en attente.",
          importance:
            "Actions :\n• Accepter (✓) : Prend en charge la conversation et la déplace dans 'En cours'.\n• Transférer (⇄) : Redirige vers un autre agent ou service.\n• Ignorer (🚫) : Écarte le message sans le comptabiliser.\n(Remarque : Pour clôturer la conversation sans l'ouvrir, utilisez l'option 'Fermer' du menu à 3 points ⋮ dans l'en-tête du chat).",
        },
        {
          id: "tab_trabajando_en",
          title: "💼 En cours (Tickets ouverts)",
          definition:
            "Conversations actives prises en charge pour échanger avec le client en envoyant messages, vocaux, fichiers et notes internes.",
          importance:
            "Actions :\n• Fermer (❌) : Clôture formellement l'intervention une fois terminée.\n• Transférer (⇄) : Réassigne la conversation active.",
        },
        {
          id: "tab_grupos",
          title: "👥 Groupes (Groupes WhatsApp)",
          definition:
            "Espace dédié au suivi et à la gestion des groupes WhatsApp d'entreprise.",
          importance:
            "Actions :\n• Fermer (❌) : Termine le cycle de suivi du groupe.\n• Transférer (⇄) : Réassigne la gestion du groupe.",
        },
      ],
    },
    {
      id: "controles_busqueda",
      title: "2. Recherche et Filtres Avancés",
      description:
        "Outils pour retrouver rapidement des échanges selon des critères précis.",
      items: [
        {
          id: "buscador_rapido",
          title: "Recherche Prédictive",
          definition:
            "Recherche instantanée par nom de contact, numéro ou mot-clé du dernier message.",
        },
        {
          id: "filtros_avanzados",
          title: "Filtres Avancés (Entonnoir, Étapes et Dates)",
          definition:
            "Filtre par marque commerciale, entonnoir CRM, étape Kanban, canal, conseiller ou étiquette.",
        },
      ],
    },
    {
      id: "acciones_chat",
      title: "3. Outils de Chat et Messagerie",
      description:
        "Fonctionnalités disponibles dans la fenêtre de conversation active lors de l'échange client.",
      items: [
        {
          id: "notas_internas",
          title: "Notes Internes et Messages Privés",
          definition:
            "Permet d'enregistrer des annotations internes invisibles pour le client et archivées dans l'historique.",
        },
        {
          id: "mensajes_programados",
          title: "Messages Programmés et Rappels",
          definition:
            "Planifie l'envoi de messages à une date et heure précises, avec options de récurrence et rappel automatique.",
        },
        {
          id: "adjuntos_multimedia",
          title: "Pièces Jointes et Multimédia",
          definition:
            "Envoi de messages vocaux en direct, fichiers audio, photos, vidéos, documents (PDF, Office) et fiches contact.",
        },
        {
          id: "transferencia",
          title: "Transfert vers un Autre Département ou Agent",
          definition:
            "Transfère le ticket vers un autre département en conservant l'intégralité de l'historique.",
        },
        {
          id: "respuestas_rapidas",
          title: "Réponses Rapides (Raccourci '/')",
          definition:
            "Saisissez '/' pour afficher des modèles préenregistrés et des messages vocaux types.",
        },
        {
          id: "disparar_flujo",
          title: "Déclenchement Manuel des Flux et Automatisations",
          definition:
            "Déclenche manuellement un flux de bot. Filtrage automatique selon la Marque et l'Entonnoir du ticket.",
        },
        {
          id: "firma_asesor",
          title: "Signature du Conseiller",
          definition:
            "Active ou désactive la signature automatique avec le nom du conseiller sur chaque message sortant.",
        },
      ],
    },
    {
      id: "accesos_cabecera",
      title: "4. Raccourcis Rapides de l'En-tête de Chat",
      description:
        "Boutons d'action rapide situés dans la barre supérieure de la conversation active.",
      items: [
        {
          id: "copiar_numero",
          title: "Copier le Téléphone / Contact",
          definition:
            "Copie le numéro du client dans le presse-papiers en un clic, en tenant compte du préfixe configuré.",
        },
        {
          id: "respuestas_rapidas_icono",
          title: "Réponses Rapides (Éclair ⚡)",
          definition:
            "Ouvre immédiatement la fenêtre des modèles de réponses rapides et audios préenregistrés.",
        },
        {
          id: "switch_chatbot",
          title: "Activer / Désactiver le Chatbot pour ce Contact",
          definition:
            "Interrupteur rapide pour suspendre ou réactiver les réponses du bot et de l'IA pour ce contact spécifique.",
        },
        {
          id: "boton_aceptar",
          title: "Bouton Accepter (Tickets en Attente)",
          definition:
            "Visible quand le ticket est En attente. Assigne l'échange à votre compte et le déplace dans 'En cours'.",
        },
      ],
    },
    {
      id: "menu_opciones_ticket",
      title: "5. Menu d'Options du Ticket (Trois Points ⋮)",
      description:
        "Options avancées de gestion disponibles dans le menu déroulant de l'en-tête.",
      items: [
        {
          id: "opcion_cerrar",
          title: "Fermer le Ticket (❌)",
          definition:
            "Clôture formellement le ticket. Permet de choisir d'envoyer ou non un message de fin (ou saisir la valeur de vente). Utilisable sur les tickets ouverts ou en attente.",
        },
        {
          id: "opcion_regresar_fila",
          title: "Retourner à la File / Département (↩️)",
          definition:
            "Libère la conversation en la désassignant de votre compte pour la renvoyer dans la file d'attente du service.",
        },
        {
          id: "opcion_transferir",
          title: "Transférer le Ticket (⇄)",
          definition:
            "Ouvre la fenêtre de transfert pour réassigner la conversation à un autre département ou agent en conservant tout l'historique.",
        },
        {
          id: "opcion_borrar",
          title: "Supprimer le Ticket (🗑️)",
          definition:
            "Supprime définitivement le ticket et son historique après confirmation. Réservé aux administrateurs.",
        },
        {
          id: "opcion_logs",
          title: "Logs du Ticket (📜)",
          definition:
            "Affiche la chronologie complète et l'audit du ticket : date de création, temps d'attente, assignations, transferts et fermetures.",
        },
        {
          id: "opcion_pdf",
          title: "Exporter en PDF (📄)",
          definition:
            "Génère et télécharge un document PDF contenant l'historique complet de la conversation, contacts, dates et messages pour vos archives.",
        },
      ],
    },
  ],
};

const ar = {
  header: {
    badge: "دليل BotMix الرسمي",
    title: "مركز الرسائل الموحد — صندوق المحادثات",
    summary:
      "صندوق المحادثات هو المركز التشغيلي الأساسي لخدمة العملاء في الوقت الفعلي. يجمع محادثات WhatsApp (Baileys وواجهة Meta الرسمية)، وFacebook Messenger، وInstagram Direct، وWeb Widget في واجهة واحدة منظمة حسب علامات التبويب والطوابير/الأقسام.",
  },
  sections: [
    {
      id: "pestanas_estados",
      title: "1. علامات تبويب التنقل وإجراءات التذكرة",
      description:
        "نوافذ العمل الثلاث الرئيسية وأزرار الإجراءات المتاحة في كل منها.",
      items: [
        {
          id: "tab_esperando",
          title: "⏳ في الانتظار (التذاكر المعلقة)",
          definition:
            "صندوق الرسائل الواردة التي لم يتسلمها وكيل بعد أو تنتظر في الطابور بعد التفاعل مع البوت. تبقى التذكرة معلقة.",
          importance:
            "الأزرار المتاحة:\n• قبول (✓): استلام المحادثة وتعيينها لك ونقلها إلى 'قيد المعالجة'.\n• تحويل (⇄): تحويل التذكرة لقسم أو وكيل آخر.\n• تجاهل (🚫): استبعاد الرسالة (غير مرغوب فيها أو خطأ) دون احتسابها كخدمة منجزة.\n(ملاحظة: إذا أردت إنهاء المحادثة دون فتحها، يمكنك استخدام خيار 'إغلاق' من قائمة النقاط الثلاث ⋮ في أعلى المحادثة).",
        },
        {
          id: "tab_trabajando_en",
          title: "💼 قيد المعالجة (التذاكر المفتوحة)",
          definition:
            "المحادثات النشطة المستلمة من قبل الوكيل للتواصل وإرسال الردود والملاحظات الصوتية والملفات.",
          importance:
            "الأزرار المتاحة:\n• إغلاق (❌): إنهاء الخدمة رسميًا بمجرد اكتمالها.\n• تحويل (⇄): تحويل المحادثة النشطة لوكيل أو قسم آخر.",
        },
        {
          id: "tab_grupos",
          title: "👥 المجموعات (مجموعات WhatsApp)",
          definition:
            "قسم مخصص لإدارة مجموعات ومجتمعات WhatsApp المرتبطة بالشركة.",
          importance:
            "الأزرار المتاحة:\n• إغلاق (❌): إنهاء دورة متابعة المجموعة.\n• تحويل (⇄): إعادة تعيين إدارة المجموعة لوكيل آخر.",
        },
      ],
    },
    {
      id: "controles_busqueda",
      title: "2. البحث والفلاتر المتقدمة",
      description:
        "أدوات لتحديد المحادثات وفقًا لمعايير محددة.",
      items: [
        {
          id: "buscador_rapido",
          title: "البحث التنبؤي",
          definition:
            "يتيح البحث الفوري بالاسم أو رقم الهاتف أو محتوى آخر رسالة.",
        },
        {
          id: "filtros_avanzados",
          title: "الفلاتر المتقدمة (المسار، المراحل والتواريخ)",
          definition:
            "نافذة لتصفية المحادثات حسب العلامة التجارية ومسار CRM ومرحلة Kanban والقناة والوكيل والوسوم.",
        },
      ],
    },
    {
      id: "acciones_chat",
      title: "3. أدوات المحادثة والمراسلة",
      description:
        "الميزات المتاحة داخل نافذة المحادثة النشطة أثناء التفاعل مع العميل.",
      items: [
        {
          id: "notas_internas",
          title: "الملاحظات الداخلية والرسائل الخاصة",
          definition:
            "تتيح للموظفين تدوين ملاحظات وتعليقات داخلية داخل المحادثة، وتكون مخفية تمامًا عن العميل ومحفوظة في سجل الشركة.",
        },
        {
          id: "mensajes_programados",
          title: "جدولة الرسائل والتذكيرات",
          definition:
            "جدولة الرسائل لإرسالها في تاريخ ووقت محددين في المستقبل، مع خيارات التكرار الدوري والتذكير الثاني.",
        },
        {
          id: "adjuntos_multimedia",
          title: "المرفقات والوسائط المتعددة",
          definition:
            "دعم شامل لإرسال الرسائل الصوتية الحية والملفات الصوتية والصور ومقاطع الفيديو ومستندات PDF وملفات Office وجهات الاتصال.",
        },
        {
          id: "transferencia",
          title: "التحويل بين الطوابير/الأقسام أو الوكلاء",
          definition:
            "تحويل التذكرة لقسم آخر (مثلاً من المبيعات للدعم) مع الاحتفاظ بكامل السجل.",
        },
        {
          id: "respuestas_rapidas",
          title: "الردود السريعة (اختصار '/')",
          definition:
            "اكتب '/' في حقل النص لعرض القوالب الجاهزة والتسجيلات الصوتية المسجلة مسبقًا.",
        },
        {
          id: "disparar_flujo",
          title: "التشغيل اليدوي للمسارات والأتمتة",
          definition:
            "تشغيل مسار للبوت يدوياً في المحادثة. تتم تصفية المسارات بذكاء حسب العلامة التجارية ومسار المبيعات للتذكرة.",
        },
        {
          id: "firma_asesor",
          title: "التوقيع التلقائي للمستشار",
          definition:
            "تفعيل أو تعطيل إدراج اسم الموظف تلقائياً في بداية كل رسالة مرسلة لخدمة مخصصة وشفافة.",
        },
      ],
    },
    {
      id: "accesos_cabecera",
      title: "4. الاختصارات السريعة لأعلى المحادثة",
      description:
        "أزرار الإجراءات السريعة الموجودة في الشريط العلوي للمحادثة النشطة.",
      items: [
        {
          id: "copiar_numero",
          title: "نسخ الهاتف / جهة الاتصال",
          definition:
            "نسخ رقم هاتف العميل إلى الحافظة بنقرة واحدة، مع مراعاة البادئة المحددة إن وجدت.",
        },
        {
          id: "respuestas_rapidas_icono",
          title: "الردود السريعة (رمز البرق ⚡)",
          definition:
            "فتح نافذة الردود السريعة والتسجيلات الصوتية الجاهزة فورًا لإرسالها للعميل.",
        },
        {
          id: "switch_chatbot",
          title: "تفعيل / تعطيل البوت لجهة الاتصال هذه",
          definition:
            "زر تبديل سريع لإيقاف أو استئناف ردود البوت والذكاء الاصطناعي حصريًا لجهة الاتصال هذه لتوفير دعم بشري خالص.",
        },
        {
          id: "boton_aceptar",
          title: "زر قبول (التذاكر في الانتظار)",
          definition:
            "يظهر عندما تكون التذكرة في قائمة الانتظار. يقوم بتعيين المحادثة لك ونقلها إلى 'قيد المعالجة' لبدء الخدمة.",
        },
      ],
    },
    {
      id: "menu_opciones_ticket",
      title: "5. قائمة خيارات التذكرة (ثلاث نقاط ⋮)",
      description:
        "خيارات إدارة متقدمة متاحة في القائمة المنسدلة في أعلى المحادثة.",
      items: [
        {
          id: "opcion_cerrar",
          title: "إغلاق التذكرة (❌)",
          definition:
            "إنهاء خدمة التذكرة رسميًا. يتيح اختيار إرسال رسالة وداع تلقائية أم لا (أو تسجيل بيانات البيع). متاح للتذاكر المفتوحة والمعلقة.",
        },
        {
          id: "opcion_regresar_fila",
          title: "العودة إلى الطابور / القسم (↩️)",
          definition:
            "إلغاء تعيين التذكرة منك وإعادتها لحالة الانتظار داخل قسمها ليتمكن أي وكيل متاح آخر من استلامها.",
        },
        {
          id: "opcion_transferir",
          title: "تحويل التذكرة (⇄)",
          definition:
            "فتح نافذة التحويل لإعادة توجيه المحادثة لقسم آخر أو لوكيل محدد مع الحفاظ على كامل السجل.",
        },
        {
          id: "opcion_borrar",
          title: "حذف التذكرة (🗑️)",
          definition:
            "حذف التذكرة وسجلها نهائيًا من قاعدة البيانات بعد تأكيد الأمان. متاح فقط لمسؤولي النظام.",
        },
        {
          id: "opcion_logs",
          title: "سجلات التذكرة (📜)",
          definition:
            "عرض التتبع الزمني الكامل وسجل التدقيق للتذكرة: تاريخ الإنشاء، أوقات الانتظار، تعيينات الوكلاء، التحويلات والإغلاق.",
        },
        {
          id: "opcion_pdf",
          title: "تصدير إلى PDF (📄)",
          definition:
            "إنشاء وتنزيل ملف PDF يحتوي على سجل المحادثة الكامل وتفاصيل جهة الاتصال والتواريخ للأرشفة الإدارية أو القانونية.",
        },
      ],
    },
  ],
};

export const TICKETS_HELP_DATA = {
  es,
  en,
  pt,
  fr,
  ar,
};
